import { render, staticRenderFns } from "./DocumentSetSb.vue?vue&type=template&id=7d8ae2a4&scoped=true"
import script from "./DocumentSetSb.vue?vue&type=script&lang=js"
export * from "./DocumentSetSb.vue?vue&type=script&lang=js"
import style0 from "./DocumentSetSb.vue?vue&type=style&index=0&id=7d8ae2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8ae2a4",
  null
  
)

export default component.exports